export default function About() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-4xl px-6 py-16 sm:py-24">
        <div className="space-y-12">
          <div className="space-y-4">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
              About STRONOM
            </h1>
            <p className="text-xl text-muted-foreground">
              Modular governance for intelligent systems.
            </p>
          </div>

          <div className="space-y-8 text-base leading-7 text-foreground/90">
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Our Mission</h2>
              <p>
                STRONOM is a universal framework shaping the next generation of
                structured intelligence. We believe that intelligent
                systems—whether AI, automation, or human-driven processes—must
                be governed by proof-based rules, transparent telemetry, and
                compliance primitives.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">The Framework</h2>
              <p>
                Every STRONOM module inherits the same core principles:
                Structure for clarity, Governance for control, Proof for
                accountability, and Trust for reliability. This modular approach
                allows us to serve diverse industries while maintaining
                consistency and rigor.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Our Modules</h2>
              <div className="grid gap-6 sm:grid-cols-2">
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-core mb-2">
                    STRONOM Core
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    The foundation of all modules. Defines structure, validates
                    logic, and governs every connected system.
                  </p>
                </div>
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-design mb-2">
                    STRONOM Design
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Enables creative industries to turn intent into structured,
                    validated design outcomes.
                  </p>
                </div>
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-build mb-2">
                    STRONOM Build
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Transforms digital projects into compliant, safe, and
                    auditable results.
                  </p>
                </div>
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-motion mb-2">
                    STRONOM Motion
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    For robotics and autonomous systems. Ensures every movement
                    follows safety rules.
                  </p>
                </div>
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-compliance mb-2">
                    STRONOM Compliance
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Ensures automated processes meet ethical and regulatory
                    standards.
                  </p>
                </div>
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-media mb-2">
                    STRONOM Media
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Maintains brand safety, content integrity, and copyright
                    compliance.
                  </p>
                </div>
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-gov mb-2">
                    STRONOM Gov
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Builds transparent and traceable digital services with
                    accountability.
                  </p>
                </div>
                <div className="rounded-lg border border-border/40 bg-background/50 p-6">
                  <h3 className="font-semibold text-stronom-agents mb-2">
                    STRONOM Agents
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Governs enterprise AI assistants with compliant and secure
                    behavior.
                  </p>
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Why STRONOM?</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li className="flex gap-3">
                  <span className="text-stronom-design">✓</span>
                  <span>
                    <strong>Proof-based:</strong> Every decision is auditable
                    and traceable
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-stronom-design">✓</span>
                  <span>
                    <strong>Modular:</strong> Pick what you need, extend as you
                    grow
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-stronom-design">✓</span>
                  <span>
                    <strong>Compliant:</strong> Built for regulated industries
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-stronom-design">✓</span>
                  <span>
                    <strong>Transparent:</strong> No black boxes, pure
                    governance
                  </span>
                </li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Get Started</h2>
              <p>
                Explore our framework by diving into STRONOM Core to understand
                the principles, then experience them in action with STRONOM
                Design and our interactive studios.
              </p>
            </section>
          </div>

          <div className="border-t border-border/40 pt-12">
            <p className="text-sm text-muted-foreground">
              Questions?{" "}
              <a
                href="mailto:contact@stronom.com"
                className="text-foreground font-medium hover:underline"
              >
                Get in touch
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
